import { Star } from "lucide-react";

const AGG_RATING = "4,9";
const AGG_COUNT = 36;
const REVIEWS_URL = "https://autosupermarket.it/concessionari/toscana/pisa/centro-auto-pontedera-di-bartoli-massimo-c-snc/recensioni";
const GOOGLE_REVIEW_URL = "https://www.google.com/maps/search/?api=1&query=Centro+Auto+Pontedera+Via+Don+Primo+Mazzolari+38+Pontedera";

const REVIEWS = [
  { name: "Anna Lisa Gneri", date: "Ottobre 2026", stars: 5, text: "Gentili, efficienti e molto precisi. Mi sono trovata benissimo." },
  { name: "Carlo Valentini", date: "Settembre 2026", stars: 5, text: "Molto professionali e con un occhio di riguardo verso il cliente." },
  { name: "Lucia Passera", date: "Febbraio 2025", stars: 5, text: "Ho portato la mia auto semidistrutta dopo un incidente. Persone gentili e professionali che mi hanno subito messo a disposizione l'auto sostitutiva. Riconsegnata prima del previsto e lavoro eseguito alla perfezione." },
  { name: "Alessandro Tozzi", date: "Agosto 2025", stars: 5, text: "Mi sono trovato bene, ottimo lavoro, grazie di tutto." },
  { name: "Aura Georgiana", date: "Settembre 2023", stars: 5, text: "Vorrei trovare parole che valessero 10 stelle. Consigliatissimo!!!" },
  { name: "Roberto Sassetti", date: "Luglio 2022", stars: 5, text: "Per me eccezionale, molto serio." },
];

const Stars = ({ n }) => (
  <div className="flex gap-0.5" aria-label={`${n} stelle su 5`}>
    {[...Array(5)].map((_, i) => (
      <Star key={i} className={`w-4 h-4 ${i < n ? "fill-[#FF9E00] text-[#FF9E00]" : "text-white/15"}`} />
    ))}
  </div>
);

export const Reviews = () => (
  <section className="max-w-7xl mx-auto px-6 pt-20 pb-2" data-testid="reviews-section">
    <div className="font-mono-tech text-xs tracking-[0.3em] uppercase amber mb-3">Dicono di noi</div>
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-10">
      <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight uppercase">Recensioni dei clienti</h2>
      <div className="flex items-center gap-3" data-testid="reviews-aggregate">
        <span className="font-display font-extrabold text-3xl text-[#FF9E00]">{AGG_RATING}</span>
        <div>
          <Stars n={5} />
          <div className="text-xs text-muted-foreground mt-0.5">su {AGG_COUNT} recensioni</div>
        </div>
      </div>
    </div>
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {REVIEWS.map((r, i) => (
        <div key={i} className="rounded-2xl bg-[#181A22] border border-white/10 p-6 flex flex-col fade-up" style={{ animationDelay: `${i * 70}ms` }} data-testid={`review-card-${i}`}>
          <Stars n={r.stars} />
          <p className="text-sm text-slate-300 leading-relaxed mt-4 flex-1">“{r.text}”</p>
          <div className="mt-5 pt-4 border-t border-white/10">
            <div className="font-semibold text-sm">{r.name}</div>
            <div className="text-xs text-muted-foreground">{r.date}</div>
          </div>
        </div>
      ))}
    </div>
    <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
      <a href={GOOGLE_REVIEW_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-full bg-[#E63946] hover:bg-[#D62828] text-white h-11 px-6 font-semibold text-sm transition-colors" data-testid="reviews-google-btn">
        <Star className="w-4 h-4 fill-white" /> Lascia una recensione su Google
      </a>
      <a href={REVIEWS_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-full border border-white/15 hover:border-[#E63946] hover:text-[#E63946] h-11 px-6 font-semibold text-sm transition-colors" data-testid="reviews-more-btn">
        Leggi tutte le {AGG_COUNT} recensioni
      </a>
    </div>
  </section>
);
